import {remCalc} from '_themeUtils'

const productSizeSelector = {
    ProductSizeSelector: {
        baseStyle: () => ({
            container: {
                gap: 'spacing.10',
            },
            drawerTitle: {
                paddingTop: {base: 'spacing.10', md: 'unset'},
                textTransform: 'none',
                textStyle: 'paragraphXl',
                fontWeight: 'normal',

                _firstLetter: {
                    textTransform: 'capitalize',
                },
            },
            helpCtasContainer: {
                w: '100%',
                justifyContent: 'space-between',
                gap: 0,
            },
            helpCta: {
                textStyle: 'paragraphSm',
            },
            helpSizesCta: {
                display: {base: 'flex'},
            },
            sizesWrapper: {
                w: '100%',
            },
            sizeItemWrapper: {
                w: '100%',
                justifyContent: 'space-between',
                // Figma (5655-4275 / 5847-11033): the slot content is inset 10px from the divider on both
                // sides; the divider itself stays full-width (it's a sibling below this row).
                px: 'spacing.2.5',
            },
            sizeItemDivider: {
                opacity: 1,
                borderColor: '#D2D2D2',
            },
            sizeItemButton: {
                w: 'auto',
                flex: '1 1',
                textAlign: 'left',
                p: '0px',
            },
            sizeItemRightButton: {
                w: 'auto',
                // Remove the Button's default horizontal padding so "Request product" ends at the same right
                // edge as the plain "only one left" text (Figma 5655-4275 / 5847-11033: both flush to the slot).
                px: 0,
                minW: 'auto',
            },
            sizeItemLabel: {
                w: '100%',
                textStyle: 'paragraphSm',
                fontWeight: 'light',
            },
            sizeItemLabelUnavailable: {
                color: 'color.text.grey.400',
            },
            labelOnlyOneLeft: {
                textStyle: 'paragraphXs',
                fontWeight: 'normal',
            },
            buttonRequest: {
                textStyle: 'paragraphXs',
                fontWeight: 'normal',
                textDecoration: 'underline',
            },
            noticeContainer: {
                w: '100%',
            },
            noticeText: {
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
            },
        }),
    },
}

export default productSizeSelector
